module.exports = __webpack_public_path__ + "static/media/slide4.0c24848b.webp";